//#region Libraries
import { useState } from "react";
import {
    useNavigate 
} from "react-router";
//#endregion
//#region Styles
import { FooterFormManualLoading } from "components/styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
import DialogAlertSuccessNotify from "components/DialogAlertNotify/DialogAlertSuccessNotify/DialogAlertSuccessNotify";
import Preloader from "components/Preloader/Preloader";
//#endregion
//#region Reducer
import { TYPES } from "../../utils/reducer/appointment.actions";
//#endregion
//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import { APPOINTMENTS_CONSTANTS } from "config/constants";
import { useNavigatingAway } from "utils/hooks/usePrompt";
import useMainContext from "utils/context/useMainContext";
import validator from "../../utils/validations";
import { requestCreateAppointment } from "services/appointment/aboutAppoinment";
import { TOAST_MUST_CORRECT_MSG } from "views/Asesorias/utils/constants";
import { TIMEOUT_HIDDEN_TOAST_MESSAGE } from "components/ToastMessage/ToastMessage";
//#endregion

const scrollToDocumentTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
const Footer = ({ 
    toStep,
    nextStep,
    form, errors,
    changeErrors,
    changeErrorText, 
    currentStep,
    canShowDialogLeavingPage,
    setCanShowDialogLeavingPage,
    setHiddenToastMessageSaveEventAsDraft,
    setMustCorrect,
}) => {
    //#region Extra
    const navigate = useNavigate();
    const mainContext = useMainContext();
    //#region Manejo de salida de vista
    const [
        showDialogLeavingPage,
        confirmNavigation,
        cancelNavigation
    ] = useNavigatingAway(canShowDialogLeavingPage);
    //#endregion
    //#endregion
    //#region States
    const [showDialogCancelAppointment, setShowDialogCancelAppointment] = useState(false);
    const [showDialogCreatedAppointment, setShowDialogCreatedAppointment] = useState(false);
    const [loadingAction, setLoadingAction] = useState({
        loading: false,
        message: ""
    });
    //#endregion
    //#region Functions
    const toggleShowDialogCreatedAppointment = (value = null) => {
        setShowDialogCreatedAppointment(
            value === null 
            ? !showDialogCreatedAppointment : value);
        if (showDialogCreatedAppointment)
            toAppointmentList();
    }
    const toggleShowDialogCancelAppointment = (value = null) => {
        setShowDialogCancelAppointment(value === null ? !showDialogCancelAppointment : value);
    }
    const cancelAppointment = async () => {
        toggleShowDialogCancelAppointment();
    }
    const saveAppoinmentData = async loadingMessage => {
        // Setteando mensaje de preloader
        setLoadingAction(prev => ({
            ...prev,
            messsage: loadingMessage
        }));
        let isValid = null;
        switch (currentStep) {
            case 1: {
                const result = validator.isValidFormStep1(form.step1, errors);
                if (result.newErrors.part1.adviser)
                    changeErrorText("adviser", "Es necesario seleccionar un asesor(a)");
                changeErrors(1, result.newErrors);
                isValid = result.isValid;
                break;
            }
            case 2: {
                const result = validator.isValidFormStep2(form.step2);
                changeErrors(2, result.newErrors);
                isValid = result.isValid;
                if (!isValid) break;
                break;
            }
            default: return false;
        }
        manageResultRequestSaveAppointment(isValid);
        // Activando preloader
        setLoadingAction(prev => ({
            ...prev,
            loading: false
        }));
        return isValid;
    }
    const showMustCorrectTemporary = (message, millis = TIMEOUT_HIDDEN_TOAST_MESSAGE) => {
        setMustCorrect({
            message,
            show: true
        });
        setTimeout(() => {
            setMustCorrect(prev => ({
                ...prev,
                show: false
            }));
        }, millis);
    }
    const manageResultRequestSaveAppointment = isValid => {
        if (isValid === null) {
            mainContext.setShowDialogUnexpectedError(true);
            return;
        }
        if (!isValid) 
            showMustCorrectTemporary(TOAST_MUST_CORRECT_MSG.INVALID_OR_INCOMPLETED);
        scrollToDocumentTop();
    }

    const showSuccessToastMessageSaveEventAsDraft = () => {
        setHiddenToastMessageSaveEventAsDraft(false);
        setTimeout(() => {
            setHiddenToastMessageSaveEventAsDraft(true);
        }, 2400);
    }
    const finalizeAppointment = async () => {
        setLoadingAction({
            message: "Creando asesoría...",
            loading: true
        });
        const { success, message } = await requestCreateAppointment(form);
        setLoadingAction(prev => ({
            ...prev,
            loading: false
        }));
        // Mostrar diálogo de asesoría creada
        if (success) {
            setShowDialogCreatedAppointment(true);
            return;
        }
        const { FORM_ACTION_ERROR_CODES, MESSAGE_ACCORDS_ERROR } = APPOINTMENTS_CONSTANTS;
        // Mostrar error de cruce de horarios
        if (message === FORM_ACTION_ERROR_CODES.CROSS_SCHEDULE) {
            showMustCorrectTemporary(TOAST_MUST_CORRECT_MSG.TIME_CROSSING, 3500);
            scrollToDocumentTop();
            return;
        }
        if (Object.values(FORM_ACTION_ERROR_CODES.FOR_ADVISER_ACCOUNT).includes(message)) {
            const newErrors = {
                ...errors.step1,
                part1: {
                    ...errors.part1,
                    adviser: true
                }
            };
            changeErrors(1, newErrors);
            changeErrorText("adviser", MESSAGE_ACCORDS_ERROR[message]);
            toStep(1);
            scrollToDocumentTop();
            return;
        }
        mainContext.setShowDialogUnexpectedError(true);
    }
    const navigationHandler = async () => {
        const isValid = await saveAppoinmentData("Guardando...");
        if (!isValid) 
            return;
        nextStep();
        showSuccessToastMessageSaveEventAsDraft();
    }
    const navigateToAppointment = () => navigate(ABSOLUTE_PATHS.APPOINTMENT);
    const toAppointmentList = () => {
        setTimeout(() => {
            navigateToAppointment();
            confirmNavigation();
        }, 380);
    }
    //#endregion
    return (
        <>
            <FooterFormManualLoading marginTop="60px">
                <CustomButton
                    variant="sixtinary"
                    text="Cancelar"
                    onClick={() => navigate(ABSOLUTE_PATHS.APPOINTMENT)}/>
                {currentStep > 2
                ? <CustomButton
                    text="Finalizar"
                    onClick={finalizeAppointment}/>
                : <CustomButton
                    text="Continuar"
                    onClick={navigationHandler}/>}
            </FooterFormManualLoading>
            <DialogAlertAction
                show={showDialogCancelAppointment}
                toggleShow={toggleShowDialogCancelAppointment}
                title="¿Deseas cancelar la creación tu asesoria?"
                content="Recuerda que esta información no se guardará y tendrás que empezar de nuevo.">
                <CustomButton
                    variant="quintinary"
                    width="130px"
                    text="Sí, salir"
                    onClick={cancelAppointment}/>
                <CustomButton
                    variant="quaternary"
                    width="130px"
                    text="No, continuar"
                    onClick={() => toggleShowDialogCancelAppointment()}/>
            </DialogAlertAction>
            <DialogAlertAction
                show={showDialogLeavingPage}
                toggleShow={cancelNavigation}
                title="¿Deseas salir de la creacion de tu asesoria?"
                content="Recuerda que al salir, la información que has escrito recientemente, no se guardará">
                <CustomButton
                    variant="quintinary"
                    text="Sí, salir"
                    width="130px"
                    onClick={confirmNavigation}/>
                <CustomButton
                    variant="quaternary"
                    text="No, continuar"
                    width="130px"
                    onClick={cancelNavigation}/>
            </DialogAlertAction>
            <DialogAlertSuccessNotify
                show={showDialogCreatedAppointment}
                toggleShow={toggleShowDialogCreatedAppointment}
                title="Hemos creado tu asesoría"
                description="Lo podrás visualizar en el listado de asesorías"
                buttons={
                    <CustomButton
                        variant="quaternary"
                        text="Ir al listado de asesorías"
                        onClick={() => {
                            toggleShowDialogCreatedAppointment(false);
                            toAppointmentList();
                        }}/>
                }/>
            <Preloader 
                hidden={!loadingAction.loading} 
                message={loadingAction.message}/>
        </>
    );
}

export default Footer;